import { TaskStatus, TaskType } from './../types/enum-type';
import { Task } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"


function taskMapper(inputTask: any): Task {
    return {
        id: inputTask.id,
        name: inputTask.name,
        taskType: inputTask.taskType,
        taskStatus: inputTask.taskStatus,
        subject: inputTask.subject,
        observation: inputTask.observation,
        numeroDeContrat: inputTask.numeroDeContrat,
        toBeDone: inputTask.toBeDone,
        laverieId: inputTask.laverieId,
        taskListId: inputTask.taskListId,
        taskListCodeTournee: inputTask.taskListCodeTournee,
        priority: inputTask.priority,
        rank: inputTask.rank,
        number: inputTask.number,
        street: inputTask.street,
        postcode: inputTask.postcode,
        city: inputTask.city,
        latitude: inputTask.latitude,
        longitude: inputTask.longitude,
        clientSignature: inputTask.clientSignature,
        startDateTime: inputTask.startDateTime,
        endDateTime: inputTask.endDateTime,
        subtasks: inputTask.subtasks || []
    };
}

export function taskMapperArray(inputArray: any[]): Task[] {
    return inputArray.map(taskMapper);
}

export async function getFilteredTasks(taskStatuses: TaskStatus[], taskTypes: TaskType[]): Promise<Task[]> {
    const params = new URLSearchParams();

    if (taskStatuses.length > 0) {
        params.set("task_statuses", taskStatuses.join(","));
    }

    if (taskTypes.length > 0) {
        params.set("task_types", taskTypes.join(","));
    }

    const query = params.toString();
    const url = query ? `tasks?${query}` : "tasks";

    const response = await getData<Task[]>(url);
    return taskMapperArray(response ?? []);
}

export async function getTasksByTaskListId(taskListId: string): Promise<Task[]> {
    const url = `/tasks?taskListId=${taskListId}`;
    const response = await getData<Task[]>(url);
    return taskMapperArray(response ?? []);
}

export function getTaskById(id: string): Promise<Task> {
    return getData("/tasks/" + id).then(
        onSucceed => {
            return taskMapper(onSucceed);
        }
    );
}

export function postTask(task: Task): Promise<Task> {
    return postData("/tasks", task).then(
        onSucceed => {
            return taskMapper(onSucceed);
        }
    );
}

export function putTask(task: Task): Promise<any> {
    return putData("/tasks/" + task.id, task)
}

export function updateTaskRank(task: Task): Promise<any> {
    return putData("/tasks/" + task.id + "/rank", { rank: task.rank })
}

export function setStartDateTime(taskId: string, startDateTime: Date): Promise<Task> {
    return putData("/tasks/" + taskId + "/start-date-time", { startDateTime })
}

export function setEndDateTime(taskId: string, endDateTime: Date): Promise<Task> {
    return putData("/tasks/" + taskId + "/end-date-time", { endDateTime })
}

export function deleteTask(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("/tasks/" + idsStr)
}

export function sendReport(taskId: string): Promise<any> {
    return postData("/tasks/send-report", { taskId });
}

export async function searchForTasks(searchQuery: string): Promise<Task[]> {
    const response = await getData<Task[]>("tasks?" + searchQuery);
    return taskMapperArray(response ?? []);
}